import { useMutation } from "@tanstack/react-query";
import { patchUserMeta } from "src/api/users";
const useUpdateUserMeta = ()=>{
    return useMutation({
        mutationFn: (userMeta)=>patchUserMeta(userMeta)
    });
};
export default useUpdateUserMeta;
